<template>
    <el-steps direction="vertical"
              :active="currentStep"
    >
        <el-step v-for="(step, index) in steps"
                 :key="$t(`layout.menus.${step}`) + '/' + step"
                 :class="{active: currentStep === index}">
            <template slot="title">
                <span class="step-title"
                      @click="()=>{redirect(index, step)}"
                      :class="{'step-title--active':
                      currentStep === index,
                      clickable: clickable(index)
                      }">
                  {{$t(`layout.menus.${step}`)}}
                </span>
            </template>
        </el-step>
    </el-steps>
</template>
<script>


export default {
  name: 'sub-menu-steps',
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  computed: {
    currentStep() {
      for (let i = 0; i < this.steps.length; i += 1) {
        const step = this.steps[i];
        if (step === this.$route.name) {
          return i;
        }
      }
      return 0;
    },
  },
  methods: {
    clickable(index) {
      return this.currentStep > index;
    },
    redirect(index, step) {
      if (this.clickable(index)) this.$router.replace({ name: step });
    },
  },
};
</script>
<style scoped lang="scss">
  .step-title{
    font-size: $--font-size-medium;
    color: $--next-dark-blue-light-opacity-60;
    padding-left: 8px;
    &--active{
      color: $--color-text-primary;
      font-weight: $--font-weight-500;
    }
  }
  ::v-deep .active  .el-step__icon{
    background-color: $--color-secondary;
    height: 14px;
    width: 14px;
    right: 1px;
  }
  ::v-deep .el-step__line{
    background-color: #253163;
  }
  ::v-deep .el-step.is-vertical .el-step__title{
      line-height: 21px;
  }

  ::v-deep  .el-step.is-vertical  .el-step__line{

    left: 5px;
    top: 10px;
    bottom: -10px;
    border-color: #253163;
  }
  ::v-deep .el-step__icon{
    width: 12px;
    height: 12px;
    background-color: #D9DCE4;
    border-color: $--color-secondary;
  }
  ::v-deep .el-step__icon-inner{
    display: none;
  }
  ::v-deep .el-step__head.is-process{}
</style>
